
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider';

const SplashScreen = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    // Set flag to indicate app was launched from PWA
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('source') === 'pwa') {
      localStorage.setItem('gambgo_launched_from_pwa', 'true');
    }
    
    // Handle browser mode
    if (urlParams.get('source') === 'browser') {
      localStorage.setItem('gambgo_use_browser_mode', 'true');
    }

    // Navigate as soon as auth is resolved; cap at 2s for branding
    const start = Date.now();
    const minSplash = 800;

    const go = () => {
      const elapsed = Date.now() - start;
      const wait = Math.max(0, minSplash - elapsed);
      setTimeout(() => {
        if (user) navigate('/home');
        else navigate('/auth');
      }, wait);
    };

    if (!loading) {
      go();
      return;
    }

    const timer = setTimeout(() => {
      if (user) navigate('/home');
      else navigate('/auth');
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate, user, loading]);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center">
      <div className="text-center flex-grow flex flex-col justify-center">
        <div className="mb-8">
          <img 
            src="/lovable-uploads/40013902-21dc-443e-b648-06fc550f98e5.png" 
            alt="GAMBGO Logo"
            className="w-64 h-64 mx-auto object-contain"
          />
        </div>
        <p className="text-2xl font-semibold text-red-600 mb-8">Delivering happiness</p>
      </div>
      <div className="mb-8 text-gray-500 text-sm">
        powered by gambgo express
      </div>
    </div>
  );
};

export default SplashScreen;
